/* eslint-disable max-len */
/**
 * Spanish translations.
 */
export default {
  ACTION: {},
  ERROR: {
    DOWNLOAD_IMAGE: 'No fue posible descargar la imagen',
    ERROR: 'Error'
  },
  HEADER: {
    DESCRIPTION: 'Descripción',
    END_DATE: 'Hasta',
    ID: 'Id.',
    START_DATE: 'El',
    TITLE: 'Título'
  },
  LABEL: {
    ACTIVES: 'Campañas activas',
    CAMPAIGNS_SIGN_OR: 'O',
    CAMPAIGNS_SIGN_PLUS: '+',
    COUPON: 'Cupón',
    DESCRIPTION: 'Descripción',
    DESIGN_REQUESTS: 'Solicitudes de diseño',
    DESIGN_REQUESTS_ACTIVES: 'Solicitudes de diseño activas',
    DESIGN_REQUESTS_TERMINATED: 'Pedidos de diseño finalizados',
    DETAIL: 'Detalle',
    END_DATE: 'Hasta',
    FILES_TITLE: 'Recursos de campañas',
    FILES_TITLE_DESIGN_REQUEST: 'Recursos para la solicitud de diseño',
    FINISHED: 'Acabada',
    FINISHED_DESIGN_REQUEST: 'Terminado',
    GENERATED: 'Generada',
    GENERIC_DESIGN: 'Diseño genérico',
    ID: 'Id.',
    IN_PROGRESS: 'En curso',
    NO_ROWS_CAMPAIGNS: 'Sin campañas',
    NO_ROWS_DESIGN_REQUESTS: 'Sin solicitudes de diseño',
    OFFER: 'Oferta',
    PREVIOUS_LEVEL: 'Nivel anterior',
    START_DATE: 'El',
    STATUS: 'Estado',
    TERMINATED: 'Campañas terminadas',
    TITLE: 'Título',
    VALUE: 'Valor'
  },
  SENTENCE: {
    ATTACHMENT_DESCRIPTION: 'No hay archivos adjuntos de la campaña (aún).',
    ATTACHMENT_DESCRIPTION_DESIGN_REQUEST:
      'No hay archivos adjuntos para esta solicitud de diseño (todavía).',
    ATTACHMENT_TITLE: 'No hay archivos adjuntos.'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
